export const MAX_NUM_QUESTIONS = process.env.REACT_APP_MAX_NUM_QUESTIONS || 20;
export const SPECIAL_QUESTION_1_NUM = process.env.REACT_APP_SPECIAL_QUESTION_1_NUM || 7;
export const SPECIAL_QUESTION_2_NUM = process.env.REACT_APP_SPECIAL_QUESTION_2_NUM || 14;
